import { render, staticRenderFns } from "./ot-calendar-holiday-table.vue?vue&type=template&id=cc870faa&scoped=true&"
import script from "./ot-calendar-holiday-table.vue?vue&type=script&lang=ts&"
export * from "./ot-calendar-holiday-table.vue?vue&type=script&lang=ts&"
import style0 from "./ot-calendar-holiday-table.vue?vue&type=style&index=0&id=cc870faa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc870faa",
  null
  
)

export default component.exports